$(document).on("click", ".sub_s", function () {

  var value = $(this).attr("value");
  var product_url = $(this).attr("product_url");
  window.location = product_url;
});

$(document).on("click", ".sp.flex .sd.grid .sub_s", function () {
  $('.sub_s').removeClass("border-active");
  $(this).addClass("border-active");

});

function reorderSlides(mainSelector, thumbsSelector) {
  var mainWrapper = document.querySelector(mainSelector + " .swiper-wrapper");
  if (mainWrapper && mainWrapper.children[3]) {
    mainWrapper.insertBefore(mainWrapper.children[3], mainWrapper.firstChild);
  }

  var thumbsWrapper = document.querySelector(thumbsSelector + " .swiper-wrapper");
  if (thumbsWrapper && thumbsWrapper.children[3]) {
    thumbsWrapper.insertBefore(thumbsWrapper.children[3], thumbsWrapper.firstChild);
  }
}





